exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-872ab7e0] .el-icon-circle-close{color:#fff}", ""]);

// exports
